/* eslint-disable */

import React, { useState, useEffect } from 'react'
import waTemplateSvc from 'services/waTemplateSvc';
import applicationSvc from "services/applicationSvc";

import Image from '_assets/images/template/ic-image.svg';
import Document from '_assets/images/template/ic-document.svg';
import Video from '_assets/images/template/ic-video.svg';
import Location from '../../_assets/svg/location.svg';
import Phone from '_assets/svg/phone.svg';
import ExLink from '_assets/svg/external-link.svg';
import HelpCircle from '_assets/svg/help-circle.svg';
import UiList from '_assets/images/template/ui-list.svg';
import ModalPhoneReview from './ModalPhoneReview';
import ArrowBlue from '_assets/images/template/arrow-left-blue.svg';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import FeatherIcon from 'feather-icons-react';
import Copycodeblue from '_assets/svg/copy-code-blue.svg';

function PhoneMediaPreview(props) {
  const { previewData, className } = props;

  const [isMasking, setMasking] = useState("");
  const [isModalPhone, showModalPhone] = useState(false);

  let preview = previewData;
  let masking = "OCA Indonesia";

  function convert(message) {
    if (message) {
      return message
        .replace(/(?:\*)((?:(?!\*|\n).)+)(?:\*)/g, '<b>$1</b>')
        .replace(/(?:_)((?:(?!\n|_).)+)(?:_)/g, '<i>$1</i>');
      // .replace(/(?:~)(?:(?!\s))((?:(?!\n|~).)+)(?:~)/g,'<s>$1</s>')
      // .replace(/(?:--)(?:(?!\s))((?:(?!\n|--).)+)(?:--)/g,'<u>$1</u>')
      // .replace(/(?:```)(?:(?!\s))((?:(?!\n|```).)+)(?:```)/g,'<tt>$1</tt>');
    }
  }

  async function handleMaskingWa() {
    await applicationSvc.getAll().then((response) => {
      console.log(response.data.data[0]._id);
      waTemplateSvc.getMaskingWa(response.data.data[0]._id).then((res) => {
        setMasking(res.data.data.whatsapp.senderName)
      })
        .catch((error) => {
          console.log(error)
        })
    }).catch(() => { });

  }


  function checkReg(str) {
    if (typeof str !== 'undefined') {
      let string = str
      string = string.replace(/_(.*?)_/g, `<i>$1</i>`)
      string = string.replace(/~(.*?)~/g, `<del>$1</del>`)
      string = string.replace(/```(.*?)```/g, `<tt>$1</tt>`)
      string = string.replace(/\*(.*?)\*/g, `<b>$1</b>`)
      string = string.replace(/(\r\n|\n|\r)/gm, "<br />");
      return { __html: string };
    }

    return { __html: str };
  }

  useEffect(() => {
    setMasking("OCA Indonesia")
    handleMaskingWa()
    if (previewData?.header) {
      // setPreviewData(previewData)
    }
  }, [])
console.log('previewData', previewData)
  const buttonData = previewData?.button;

  let mappingButton = [
    {
      type: "BUTTONS",
      text: "",
      buttonType: 'CTA',
      url: "",
      buttons: []
    },
    {
      type: "BUTTONS",
      text: "",
      buttonType: 'QUICK_REPLY',
      url: "",
      buttons: []
    },
  ]
  if(buttonData.length > 0 && previewData.button[0].type !=="copy_code"){
    buttonData.forEach((item) => { 
      if(item.order) {
        if(item.type === 'QUICK_REPLY' || item.type === 'quick_reply' || item.type === 'marketing_disapproval'){
          mappingButton[item.order].buttonType = 'QUICK_REPLY'
          mappingButton[item.order].buttons.push(item)
        } else{
          mappingButton[item.order].buttonType = 'CTA'
          mappingButton[item.order].buttons.push(item)
        }
      } else {
          if(item.type === 'QUICK_REPLY' || item.type === 'quick_reply' || item.type === 'marketing_disapproval'){
          mappingButton[0].buttonType = 'QUICK_REPLY'
          mappingButton[0].buttons.push(item)
        } else{
          mappingButton[1].buttonType = 'CTA'
          mappingButton[1].buttons.push(item)
        }
      }
    })
  }


  let sliceButtons = []
  if(buttonData.length > 0 && previewData.button[0].type !=="copy_code"){
    mappingButton.forEach((result, btnIndex) => {
      if(result.buttonType === 'QUICK_REPLY'){
        result.buttons.forEach((item, index) =>{
          sliceButtons.push({
            type: item.type,
            text: item.text || item.button_info.button_text,
            button_index: index,
            order: btnIndex,
            section: 'quick_reply',
            button_info: {
              button_text: item.text,
            },
          })
        })
      }

      if(result.buttonType === 'CTA'){
        result.buttons.forEach((item, index) =>{
          if(item.type === 'PHONE_NUMBER'){
            sliceButtons.push({
              type: item.type,
              text: item.text || item.button_info.button_text,
              phone_number: item.phone_number,
              button_index: index,
              order: btnIndex,
              section: 'cta',
              button_info: {
                phone_number: item.phone_number,
                button_text: item.text,
                type: item.type,
                value: item.value
              },
            })
          }else if(item.type === 'URL' || item.type === 'static' || item.type === 'url_dynamic'){
            let dataTemp = {
              type: item.type,
              text: item.text || item.button_info.button_text,
              url: item.websiteUrl,
              button_index: index,
              order: btnIndex,
              section: 'cta',
              button_info: {
                button_text: item.text,
                url: item.websiteUrl
              }
            }
            // console.log('isArray', item?.dataStructure)
            if(item?.example?.length>0){
              const regexp = /{{([0-9]+)}}/gm

              const matched = dataTemp.url.match(regexp)
          
              if(matched?.length > 0){
                dataTemp.url = dataTemp.url + '/{{1}}'
              }
              dataTemp.example = item?.example;
            }
           
            sliceButtons.push(dataTemp)
          }else{
            sliceButtons.push({
              type: item.type,
              text: item.text || item.button_info.button_text,
              button_index: index,
              order: btnIndex,
              section: 'cta',
              button_info: {
                button_text: item.text,
                copy_promo_code: item.copy_promo_code
              },
            })
          }
        })
      }
    })
  }

  const countButton = mappingButton[0].buttons.length + mappingButton[1].buttons.length;
  

  // console.log('sliceButtons', sliceButtons, countButton)
  // console.log('buttonData', buttonData, sliceButtons)
  // console.log('mappingButton', mappingButton)
  return (
    <div className={`phone-middle  ${className}`}>
      <div className="phone-preview position-relative mx-lg-3">
        {/* <div className="head-name">
          {isMasking &&
            <span className="inisial h6">{isMasking[0]}</span>
          }
          <span className="ms-2">{isMasking}</span>
        </div> */}
        <div className="preview-text custom-scrollbar p-3">
          <div className="mb-2">
            <div className={`${previewData?.message ? '' : 'd-none'} sms-text`}>
              <div className={`${previewData?.header?.type && previewData?.header?.type != 'text' && previewData?.header?.type != 'none' ? '' : 'd-none'} picture_template mb-2`}>
                <OverlayTrigger
                  placement="left"
                  overlay={
                  <Tooltip id="button-tooltip-2">
                    The media (images, videos, documents, and locations) shown is only a preview. The media that will be received by the recipient of the message is the media that you have attached at the time of submitting the template.
                  </Tooltip>}
                >
                  <span className='d-flex tooltip_preview_template'>
                    <FeatherIcon icon="info" className="cursor-pointer cl-white ms-2" />
                  </span>
                </OverlayTrigger>
                <img className={`${previewData?.header?.type == 'image' ? '' : 'd-none'} icon w-100`} src={Image} alt="" />
                <img className={`${previewData?.header?.type == 'document' ? '' : 'd-none'} icon w-100`} src={Document} alt="" />
                <img className={`${previewData?.header?.type == 'video' ? '' : 'd-none'} icon w-100`} src={Video} alt="" />
                <img className={`${previewData?.header?.type == 'location' ? '' : 'd-none'} icon w-100`} src={Location} alt="" />
              </div>
              <h6 className={`${previewData?.header?.text} preview-header mb-2 text-xs font-semibold`}>{previewData?.header?.text}</h6>
              <div className="mb-0 pre-wrap mb-2" dangerouslySetInnerHTML={checkReg(previewData?.message)} />
              {/* <div className="mb-0 pre-wrap">{convert(previewData?.message)}</div> */}
              <h6 className={`mb-2 fsize-12 fweight-400 cl-grey-80`}>
                  {previewData?.footer?.text} {previewData?.category_template === 'AUTHENTICATION' ? previewData?.footer?.times : ''}
              </h6>

              {/* BUTTONS */}
              {buttonData.length && previewData?.button[0]?.type !== "copy_code" && (
                  <div className={`call_to_action border-top`}>
                    { countButton < 4 &&
                      <div>
                        {mappingButton.map((item, idxButton) => {
                        return <div key={idxButton} >
                          {item.buttonType === 'CTA' ?
                          <div >
                            {item.buttons.map((resultButton, idx) => {
                              return <div key={idx} className='d-flex flex-wrap'>
                                <button className="btn add-btn pt-1 mx-1">
                                  <img width="16" height="16" className={`${resultButton.type === 'PHONE_NUMBER' || resultButton.type === 'phone_number' ? '' : 'd-none'} me-2`} src={Phone} alt="" />
                                  <img width="16" height="16" className={`${resultButton.type === 'URL' || resultButton.type === 'url' || resultButton.type === 'url_dynamic' || resultButton.type === 'static' ? '' : 'd-none'} me-2`} src={ExLink} alt="" />
                                  {resultButton?.text || resultButton?.button_info?.button_text}
                                </button>
                              </div> 
                            })} 
                          </div>
                          : ''}

                          {item.buttonType === 'QUICK_REPLY' ?
                            <div >
                              {item.buttons.map((resultButton, idx) => {
                                return <div key={idx} className='d-flex flex-wrap'>
                                    <button className="btn add-btn pt-1 mx-1">
                                    <img width="14" height="14" className={`me-2`} src={ArrowBlue} alt="" />
                                    {/* <img width="16" height="16" className={`${val.type === 'phone' ? '' : 'd-none'} mr-2`} src={Phone} alt="" />
                                    <img width="16" height="16" className={`${val.type === 'link' ? '' : 'd-none'} mr-2`} src={ExLink} alt="" /> */}
                                  
                                    {resultButton?.text || resultButton?.button_info?.button_text}
                                  </button>
                                </div>
                              })}
                            </div>
                          : ''}
                        </div>
                      })}
                      </div>
                    }

                    {countButton > 3 && 
                      <div className='text-center'>
                        {sliceButtons.slice(0,2).map((resultButton, idx) => {
                            return <div key={idx} className='d-flex flex-wrap'>
                            <button className="btn add-btn pt-1 mx-1 box-shadow-none">
                              <img width="16" height="16" className={`${resultButton.type === 'PHONE_NUMBER' || resultButton.type === 'phone_number' ? '' : 'd-none'} me-2`} src={Phone} alt="" />
                              <img width="16" height="16" className={`${resultButton.type === 'URL' || resultButton.type === 'url' || resultButton.type === 'url_dynamic' || resultButton.type === 'static' ? '' : 'd-none'} me-2`} src={ExLink} alt="" />
                              {resultButton?.text || resultButton?.button_info?.button_text}
                            </button>
                          </div> 
                        })}
                        <div onClick={()=>showModalPhone(true)} className='d-flex align-items-center justify-content-center cursor-pointer py-1'>
                          <img width="16" height="16" className="me-2" src={UiList} alt="" />
                          <span className='cl-blue'>See all options</span>
                        </div>
                      </div>
                    }
                  </div>
              )}

              {buttonData.length && previewData.button[0].type === "copy_code" && (
                <div className={`call_to_action border-top`}>
                  {previewData?.button?.map((val, index) => {
                    return <button key={index} className="btn add-btn mt-1 mx-1 box-shadow-none w-100">
                      <img src={Copycodeblue} alt='Copycodeblue' className='me-2' />
                      {val.button_info.button_text}
                    </button>
                  })}
                </div>
              )}
            </div>

          </div>
        </div>

        <div>
          {isModalPhone && (
            <ModalPhoneReview buttonData={mappingButton} showModalPhone={showModalPhone} />
          )}
        </div>
      </div>
    </div>
  )
}

export default PhoneMediaPreview